<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import useThemePreferenceStore from '~/domain/dashboard/settings/erp/shared/stores/useThemePreferemceStore'

const { isDark } = storeToRefs(useThemePreferenceStore())

const logoSrc = computed(() => {
  return isDark.value ? '/tray-logo-dark.png' : '/tray-logo.png'
})
</script>

<template>
  <img
    :src="logoSrc"
    alt="Tray Logo"
    class="tray-logo"
  >
</template>

<style scoped>
.tray-logo {
  height: 80%;
  object-fit: contain;
  transition: opacity 0.3s ease;
}
</style>
